export const tests = {
    route: 'Tests',
    smartPiTests: 'SmartPi'
};
